import useClient from 'hooks/useClient';
import { Briefcase } from 'react-feather';
import { ButtonClientPicker } from 'components/ButtonClientPicker';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ViewPage from 'components/ViewPage';

const ClientRequiredContent = ({ children }) => {
  ClientRequiredContent.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  };

  const { t } = useTranslation();
  const { hasSelectedClient } = useClient();

  return !hasSelectedClient ? (
    <ViewPage>
      <span className="d-flex align-items-center gap-2 align-middle">
        <span className="h3">{t('order.selClient')}</span>
        <ButtonClientPicker>
          <span className="p-2 rounded-circle bg-light nav-link" role="button">
            <Briefcase />
          </span>
        </ButtonClientPicker>
      </span>
    </ViewPage>
  ) : (
    children
  );
};

export default ClientRequiredContent;
